import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=60af151a"
import script from "./UserPreferences.vue?vue&type=script&lang=js"
export * from "./UserPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&id=60af151a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports